import React from 'react'
import Link from 'gatsby-link'
import { connect } from 'react-redux'

const LoggedInAs = ({ user, logout }) => {
  if (user === null) {
    return (
      <Link to="/inloggning" className="btn btn-secondary btn-sm">
        Logga in
      </Link>
    )
  }

  return (
    <span>
      Inloggad som <strong>{user.username}</strong>
      &nbsp;
      <button onClick={logout} className="btn btn-outline-secondary btn-sm">
        Logga ut
      </button>
    </span>
  )
}

const mapStateToProps = ({ user }) => {
  return { user }
}

const mapDispatchToProps = dispatch => {
  return { logout: () => dispatch({ type: 'LOGOUT_REQUESTED' }) }
}

const ConnectedLoggedInAs = connect(mapStateToProps, mapDispatchToProps)(
  LoggedInAs
)

class SiteNavi extends React.Component {
  render() {
    const { location, title } = this.props
    return (
      <nav className="navbar navbar-expand navbar-dark flex-column flex-md-row bg-primary">
        <div className="container">
          <Link className="text-center" to="/">
            <h1 className="navbar-brand mb-0">{title}</h1>
          </Link>
          <span className="navbar-nav-scroll">
            <ul className="navbar-nav bd-navbar-nav flex-row">
              <li
                className={
                  location.pathname === '/' ? 'nav-item active' : 'nav-item'
                }
              >
                <Link to="/" className="nav-link">
                  Start
                </Link>
              </li>
              <li
                className={
                  location.pathname === '/om/' ? 'nav-item active' : 'nav-item'
                }
              >
                <Link to="/om/" className="nav-link">
                  Om
                </Link>
              </li>
              <li
                className={
                  location.pathname === '/nyheter/'
                    ? 'nav-item active'
                    : 'nav-item'
                }
              >
                <Link to="/nyheter/" className="nav-link">
                  Nyheter
                </Link>
              </li>
            </ul>
          </span>
          <span className="navbar-text">
            <ConnectedLoggedInAs />
          </span>
        </div>
        <div className="navbar-nav flex-row ml-md-auto d-none d-md-flex" />
      </nav>
    )
  }
}

export default SiteNavi



// WEBPACK FOOTER //
// ./src/components/SiteNavi/index.jsx